import { render, staticRenderFns } from "./JobInsights.vue?vue&type=template&id=a751f138&scoped=true"
import script from "./JobInsights.vue?vue&type=script&lang=js"
export * from "./JobInsights.vue?vue&type=script&lang=js"
import style0 from "./JobInsights.vue?vue&type=style&index=0&id=a751f138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a751f138",
  null
  
)

export default component.exports